import type { ComponentType } from "react";
import type { RouteObject } from "react-router-dom";

let RedgerlabSideBarMenu: ComponentType | null = null;
let redgerlabRoutes: RouteObject | null = null;

if (process.env.REACT_APP_REDGERLAB === "1") {
    RedgerlabSideBarMenu = require("./Redgerlab/components/RedgerlabSideBarMenu").default;
    redgerlabRoutes = require("./Redgerlab/routes").default;
}

export { RedgerlabSideBarMenu, redgerlabRoutes };
